import React, { useRef, useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Space, Divider, Button, Table, Statistic, Tabs } from 'antd';
import { motion } from 'motion/react';
import { EyeOutlined,TeamOutlined,BarChartOutlined } from '@ant-design/icons';
import { dateFormat } from '../../utils';
import AddStage from '../../components/AddStage';
import * as Setting from '../../utils/AuthUtils';
import UsageRatePie from '../../components/UsageRatePie';
import DeckPerformancePlot from '../../components/DeckPerformancePlot';
import { MeContext } from './../../context';


function Season(props) {
  // console.warn('props di season: ', props);
  const ref = useRef(null);
  const metagameref = useRef(null);
  // const [isAdmin, setIsAdmin] = useState(false);
  const me = useContext(MeContext);
  const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});

  useEffect(() => {
    // console.warn('onEffect di League page!');
    const rights = {isAdmin: false, isReferral: false};
    rights.isAdmin = (me && me.payLoad ? me.payLoad.isAdmin : false)
    const lid = (me && me.payLoad ? me.payLoad.leaguesManaged : 0)
    const lref = (props.season.data && props.season.data.payLoad ? props.season.data.payLoad.hostingLeague.id : 0)
    // console.warn('valori di lid e props.id: ', lid, ' , ', lref);
    rights.isReferral = (lid === lref ? true : false)
    // console.warn('stato di hasRights: ', hasRights);
    setHasRights(rights)
  }, [me,props])

  const stageCols = [
    {
      title: 'Stage',
      dataIndex: 'name',
      key: 'name', 
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date) => dateFormat(date)
    },
    {
      title: 'Round',
      dataIndex: 'round',
      key: 'round',
    },
    {
      title: 'Players',
      dataIndex: 'playerAttendancy',
      key: 'playerAttendancy',
    },
    {
      title: '',
      dataIndex: 'id',
      render: (state, record) => (<Space><Link to={'/stages/'+record.id+'/'}>
                  <EyeOutlined />
              </Link>
              </Space>),
    }
  ];

  const rankCols = [
    {
      title: 'Rank',
      dataIndex: 'id',
      key: 'position',
      render: (t,r,index) => <span>{index+1}</span>
    },
    {
      title: 'Player',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Points',
      dataIndex: 'totalPoints',
    }
  ];

  const dsCols = [
    {
      title: 'Deck',
      dataIndex: 'deckName',
      key: 'deckName',
    },
    {
      title: 'Usage',
      dataIndex: 'usageCount',
      key: 'usageCount',
    },
    {
      title: 'Usage Rate(%)',
      dataIndex: 'usageRate',
      key: 'usageRate',
    },
    {
      title: 'Points per Match',
      dataIndex: 'pointsRate',
      key: 'pointsRate',
    }
  ]

  const rankFullCols = [
    {
      title: 'Rank',
      dataIndex: 'id',
      key: 'position',
      render: (t,r,index) => <span>{index+1}</span>
    },
    {
      title: 'Player',
      dataIndex: 'name',
      key: 'name', 
    },
    {
      title: 'Total Pts',
      dataIndex: 'totalPoints',
    },
    {
      title: 'Stages Played',
      dataIndex: 'stagesPlayed',
    },
    {
      title: 'Stages Won(perfect)',
      dataIndex: 'stagesWon',
      render: (_, record) => <span>{record.stagesWon}({record.stagesPerfect})</span> 
    },
    {
      title: 'Points per Stage',
      dataIndex: 'pointsPerStage',
    },
    {
      title: 'Tiebreakers',
      dataIndex: 'tiebreaker',
    },
  ];

  function toggleViewRank(e) {
    e.preventDefault();
    ref.current?.scrollIntoView({behavior: 'smooth'});
    // navigate('#full-ranking-table', { replace: true });

  }

  function toggleViewMetagameStats(e) {
    e.preventDefault();
    metagameref.current?.scrollIntoView({behavior: 'smooth'});
  }

  function numbersPlayers(stages, rank) {
    if (stages && stages.length > 0) {
      var tp = 0;
      var besttp = 0;
      var count = 0;
      var bestcount = 0;
      var tup = rank.length;
      stages.forEach(stage => {
        if (stage.isDone) { 
          count++;
          tp += stage.playerAttendancy;
        }
      });
      const ordStages = stages.slice();
      ordStages.sort((a,b) => b.playerAttendancy - a.playerAttendancy)
      for (let i = 0; i < ordStages.length && i < 6; i++) {
        if (ordStages[i].isDone) {
          bestcount++;
          besttp += ordStages[i].playerAttendancy;
        }
      }
      return {
        totalUniquePlayers: tup,
        totalPlayers: tp,
        averagePlayers: (count > 0 ? tp/count : 0),
        bestAveragePlayers: (bestcount > 0 && bestcount >= 6 ? besttp/bestcount : 'N.A.(Not reached six stages)')
      };
    }
    return {
      totalUniquePlayers: '',
      totalPlayers: '',
      averagePlayers: '',
      bestAveragePlayers: '',
    }
  }

  const season = (props.season.data && props.season.data.payLoad !== null ? props.season.data.payLoad : {});
  const league = (props.season.data && props.season.data.payLoad !== null ? props.season.data.payLoad.hostingLeague : {});
  const stages = (props.stages.data && props.stages.data.payLoad !== null ? props.stages.data.payLoad : []);
  const top8 = (props.ranking.data && props.ranking.data.payLoad !== null ? props.ranking.data.payLoad.slice(0,8) : [])
  const rank = (props.ranking.data && props.ranking.data.payLoad !== null ? props.ranking.data.payLoad : [])
  const metagame = (props.metagame.data && props.metagame.data.payLoad !== null ? props.metagame.data.payLoad : [])
  const seasonId = (props.season.data && props.season.data.payLoad !== null ? props.season.data.payLoad.id : 0);
  const tabItems = [
    {
      key: 'usageRate',
      label: 'Decks Used',
      children: <UsageRatePie metagame={metagame} height={{ height: '650px' }}/>
    },
    {
      key: 'deckPerformance',
      label: 'Decks Performances',
      children: <DeckPerformancePlot metagame={metagame} height={{ height: '650px' }}/>
    },
    {
      key: 'rawData',
      label: 'General Stats',
      children: <Table columns={dsCols} dataSource={metagame} pagination={false} loading={props.metagame && !props.metagame.fulfilled && props.metagame.pending} scroll={{y:650}} />,
    }
  ]

  // 
  // console.warn(dataset);
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
    <h1>
      {league.leagueName} - {season.name}
    </h1>
    <Card loading={props.season.isPending || props.metagame.isPending || props.ranking.isPending || props.stages.isPending}>
      <Row gutter={16}>
        <Col span={6}>
          <Statistic title="Participants" value={numbersPlayers(stages,rank).totalUniquePlayers} prefix={<TeamOutlined />} />
        </Col>
        <Col span={6}>
          <Statistic title="Partecipants per Stage" value={numbersPlayers(stages,rank).averagePlayers} prefix={<TeamOutlined />} />
        </Col>
        <Col span={6}>
          <Statistic title="Best Six Stage" value={numbersPlayers(stages,rank).bestAveragePlayers} prefix={<TeamOutlined />} />
        </Col>
        <Col span={6}>
          <Statistic title="Decks Used" value={metagame.length} prefix={<BarChartOutlined />}/>
        </Col>
      </Row>
      <Divider>Summary</Divider>
      <Row gutter={[16, 24]} style={{ marginBottom: '20px' }} type="flex">
        <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8} style={{ 'display': 'inline-flex' }}>
          <Card title="Stages" style={{ 'width': '100%' }}>
            <Table
              columns={stageCols} 
              dataSource={stages} 
              pagination={false} 
              loading={props.stages && props.stages.isPending}
              scroll={{y:440}}
            />
            { Setting.isLoggedIn() && (hasRights.isAdmin === true || hasRights.isReferral === true) && 
              <AddStage seasonId={seasonId} />
            }
          </Card>
        </Col>
        <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8} style={{ 'display': 'inline-flex' }}>
          <Card title="Top 8" style={{ 'width': '100%' }}>
            <Table
              columns={rankCols} 
              dataSource={top8} 
              pagination={false} 
              loading={props.ranking && props.ranking.isPending}
            />
            <Button style={{ marginTop: 16 }} type="primary" onClick={toggleViewRank}>VIEW FULL RANKING</Button>
          </Card>
        </Col>
        <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8} style={{ 'display': 'inline-flex' }}>
            <Card title="Metagame Stats" style={{ 'width': '100%' }}>
              <UsageRatePie metagame={metagame} />
              <Button style={{ marginTop: 16 }} type="primary" onClick={toggleViewMetagameStats}>VIEW FULL STATS</Button>
            </Card>
        </Col>
      </Row>
      <Divider>Season Ranking</Divider>
      <Row>
        <Col span={24}>
          <Card id='full-ranking-table' ref={ref}>
              <Table
                rowClassName={(record, index) => index < 8 ? 'table-row-qualified' :  '' } 
                columns={rankFullCols} 
                dataSource={rank} 
                pagination={false} 
                loading={props.ranking && props.ranking.isPending}
              />
          </Card>
        </Col>
      </Row>
      <Divider>Metagame Breakdown</Divider>
      <Row>
        <Col span={24}>
          <Card id='full-metagame-table' ref={metagameref}>
            <Tabs 
              centered
              items={tabItems}
            />
          </Card>
        </Col>
      </Row>
    </Card>
    </motion.div>
  );
}

export default Season;
// export default Domanda;